import { render, staticRenderFns } from "./OpportunityDateStatus.vue?vue&type=template&id=51a9f544&"
import script from "./OpportunityDateStatus.vue?vue&type=script&lang=js&"
export * from "./OpportunityDateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports